import { render } from "./S127603.vue?vue&type=template&id=697f0d6a"
const script = {}
script.render = render

export default script